/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of milestone action - determines how the milestone is rendered and tracked
 * @export
 */
export const MilestoneSubtype = {
    GAME: 'GAME',
    PHOTO: 'PHOTO',
    SOCIAL: 'SOCIAL',
    WEBHOOK: 'WEBHOOK',
    REFERRAL: 'REFERRAL',
    CODE_ENTRY: 'CODE_ENTRY',
    QR_SCAN: 'QR_SCAN',
    DATA_COLLECTION: 'DATA_COLLECTION'
} as const;
export type MilestoneSubtype = typeof MilestoneSubtype[keyof typeof MilestoneSubtype];


export function instanceOfMilestoneSubtype(value: any): boolean {
    for (const key in MilestoneSubtype) {
        if (Object.prototype.hasOwnProperty.call(MilestoneSubtype, key)) {
            if (MilestoneSubtype[key as keyof typeof MilestoneSubtype] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MilestoneSubtypeFromJSON(json: any): MilestoneSubtype {
    return MilestoneSubtypeFromJSONTyped(json, false);
}

export function MilestoneSubtypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneSubtype {
    return json as MilestoneSubtype;
}

export function MilestoneSubtypeToJSON(value?: MilestoneSubtype | null): any {
    return value as any;
}

export function MilestoneSubtypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MilestoneSubtype {
    return value as MilestoneSubtype;
}

